import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalRouteGuardService, PendingChangesGuard } from '@payments';
import { AuthGuard, AuthIdentityService, AuthModule, IdentityService, NoAuthGuard } from '@sfey/auth';
import { I18nModule, compiler, httpLoader as loader } from '@sfey/i18n';
import { FuseCoreModule } from '@sfey/ui/fuse-core';
import { FuseLayoutComponent, FuseLayoutModule } from '@sfey/ui/fuse-layout';
import { NotificationsModule } from '@sfey/ui/notifications';
import { AppComponent } from './app.component';
import authModuleConfig from './auth-module.config';
import { ApiBaseurlInterceptor } from './interceptors/api-baseurl.interceptor';
import { ApiErrorInterceptor } from './interceptors/api-error.interceptor';
import { MaintenanceComponent } from './maintenance/maintenance.component';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    {
        path: '',
        component: FuseLayoutComponent,
        data: {
            layout: 'empty',
        },
        loadChildren: () => import('./payments/payments.module').then((m) => m.PaymentsModule),
    },
    {
        path: 'login',
        component: FuseLayoutComponent,
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        data: { layout: 'empty' },
        children: [
            {
                path: '',
                pathMatch: 'full',
                loadChildren: () => import('@sfey/auth').then((m) => m.LoginModule),
            },
        ],
    },
    {
        path: 'admin',
        canActivate: [AuthGuard],
        loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    },
    {
        path: 'maintenance',
        component: MaintenanceComponent,
    },
    { path: 'secured', redirectTo: 'admin' },
    { path: '**', redirectTo: 'login' },
];

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        FuseCoreModule,
        FuseLayoutModule,
        I18nModule,
        NotificationsModule,
        AuthModule.forRoot(authModuleConfig),
        TranslateModule.forRoot({ compiler, loader }),
        RouterModule.forRoot(routes)], providers: [
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill', floatLabel: 'always' } },
        { provide: HTTP_INTERCEPTORS, useClass: ApiBaseurlInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ApiErrorInterceptor, multi: true },
        { provide: IdentityService, useClass: AuthIdentityService },
        PendingChangesGuard,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {
    constructor(private globalRouteGuardService: GlobalRouteGuardService) {
        this.globalRouteGuardService.ensureGlobalGuards();
    }
}
